import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "bread" }
const _hoisted_3 = { class: "menu" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "user-info" }
const _hoisted_6 = { class: "user-avatar" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "user-name" }
const _hoisted_9 = { class: "btns" }

import { ref, watch } from 'vue'
import { useUserStore } from '@/store'
import { MenuFoldOutlined, MenuUnfoldOutlined, HomeOutlined, KeyOutlined, LogoutOutlined } from '@ant-design/icons-vue'
import { useRoute } from 'vue-router'
import { Route } from 'ant-design-vue/es/breadcrumb/Breadcrumb'
import router from '@/router'


export default /*@__PURE__*/_defineComponent({
  __name: 'ConsoleHeader',
  emits: ['collapsed'],
  setup(__props, { emit: __emit }) {

const route = useRoute()
const collapsed = ref(false)
const routes = ref<Route[]>([])
const userStore = useUserStore()
const userInfo = ref(userStore.userInfo)

// eslint-disable-next-line no-undef
const emit = __emit

const onCollapsed = () => {
  collapsed.value = !collapsed.value
  emit('collapsed', collapsed.value)
}
const onBackHome = () => {
  console.log('111')
}
const onLogout = () => {
  userStore.onLogout().then(() => {
    router.push({ name: 'manage-login' })
  })
}

const updateRoute = () => {
  const { matched } = route
  const list: Route[] = []
  matched.forEach((e) => {
    list.push({
      path: (e.path === '/manage' || e.path === '/account') ? '/manage' : e.path,
      breadcrumbName: (e.path === '/manage' || e.path === '/account') ? '首页' : e.meta.title as string
    })
  })

  routes.value = list
}

watch(route, () => {
  // console.log('路由变化', e)
  updateRoute()
}, { immediate: true })

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          href: "",
          onClick: _withModifiers(onCollapsed, ["prevent","stop"])
        }, [
          (!collapsed.value)
            ? (_openBlock(), _createBlock(_unref(MenuFoldOutlined), { key: 0 }))
            : (_openBlock(), _createBlock(_unref(MenuUnfoldOutlined), { key: 1 }))
        ])
      ]),
      _createElementVNode("a", {
        href: "",
        onClick: _withModifiers(onBackHome, ["prevent","stop"]),
        style: {"color":"rgba(0, 0, 0, 0.45)","font-size":"14px","margin-right":"2px"}
      }, [
        _createVNode(_unref(HomeOutlined))
      ]),
      _createVNode(_component_a_breadcrumb, {
        routes: routes.value,
        separator: ">"
      }, {
        itemRender: _withCtx(({ route, routes }) => [
          (routes.indexOf(route) === routes.length - 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(route.breadcrumbName), 1))
            : (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: route.path
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(route.breadcrumbName), 1)
                ]),
                _: 2
              }, 1032, ["to"]))
        ]),
        _: 1
      }, 8, ["routes"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_router_link, { to: "/account/info" }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: userInfo.value?.avatar,
              alt: userInfo.value?.name
            }, null, 8, _hoisted_7)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_router_link, { to: "/account/info" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(userInfo.value?.name ?? userInfo.value?.nickname), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_a_tooltip, null, {
          title: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode("修改密码")
          ])),
          default: _withCtx(() => [
            _createVNode(_component_router_link, { to: "/account/safe" }, {
              default: _withCtx(() => [
                _createVNode(_unref(KeyOutlined)),
                _cache[1] || (_cache[1] = _createTextVNode("  修改密码 "))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_tooltip, null, {
          title: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode("退出登录")
          ])),
          default: _withCtx(() => [
            _createElementVNode("a", {
              onClick: _withModifiers(onLogout, ["stop"])
            }, [
              _createVNode(_unref(LogoutOutlined)),
              _cache[3] || (_cache[3] = _createTextVNode("   退出登录 "))
            ])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})